<div class="pinned-contact-card" (click)="onClick()">
  <div class="checkbox-wrapper">
    <mat-checkbox [checked]="user()?.selected" class="inline-checkbox"></mat-checkbox>
  </div>
  <div class="user-info-container">
    <div class="user-details">
      <div class="username-pinned-row">
        <div class="username">
          <span matTooltip="{{ user()?.firstName || '-' }} {{ user()?.lastName || '-' }}">
            {{ user()?.firstName || '-' }} {{ user()?.lastName || '-' }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="initials-container">
    @if (showPinIcon()) {
      <button
        class="pin-button"
        [class.pinned]="isPinned"
        (click)="onPinClick($event, true)"
        type="button"
        tabindex="0"
        [matTooltip]="unpinContactTooltip"
        >
        <span
          class="pin-icon"
        [ngClass]="{
          'icon-pin-icon': isPinned,
          'icon-pin-icon-unpinned': !isPinned,
        }"
        ></span>
      </button>
    }
  </div>
</div>
